import React, { useEffect, useState } from 'react'
import ShopNow from 'pages/home/ShopNow'
import Layout from 'global/layout/Layout'
import HowToParticipate from 'pages/home/HowToParticipate'
import queryString from 'query-string'
import { confirmEmailChange } from 'services/profile'
import { verifyEmailAddress } from 'services/user'
import { LandingPageModal } from 'components/modal/submodals/LandingPageModal'
import { HeroSection } from 'components/HeroSection'

import header from 'images/home/header.jpg'

import Logos from 'pages/home/Logos'
import * as styles from 'pages/home/Homepage.module.scss'
import SEO from 'breaktime-theme/src/global/layout/Seo'

const IndexPage = () => {
  const [dialog, setDialog] = useState({
    isOpen: false,
    title: null,
    content: null,
  })

  useEffect(() => {
    const qs = queryString.parse(window.location.search)
    // console.log(`qs`, qs)
    if (qs.action) {
      if (qs.action === 'confirmEmailChange') {
        // console.log(`token` ,qs.token)
        confirmEmailChange(qs.token).then(response => {
          if (response.status === 200) {
            setDialog({
              isOpen: true,
              title: 'Success',
              content: 'Your email change was successful.',
            })
          } else {
            setDialog({
              isOpen: true,
              title: 'Error',
              content: `Your email change was not successful. Please try again.`,
            })
          }
        })
      }
      if (qs.action === 'verifyEmailAddress') {
        // console.log(`token` ,qs.token)
        verifyEmailAddress(qs.token).then(response => {
          if (response.status === 200) {
            setDialog({
              isOpen: true,
              title: 'Success',
              content: 'Your account verification was successful.',
            })
          } else {
            setDialog({
              isOpen: true,
              title: 'Error',
              content: `Your account verification was not successful. Please try again.`,
            })
          }
        })
      }
    }
  }, [])

  const handleClose = () => {
    setDialog({ isOpen: false })
  }

  return (
    <Layout>
      <SEO title="CP Rewards" lang="en" />
      <div className={styles.app}>
        <HeroSection
          title={<>Thanks for Visiting!</>}
          subtitle="The program has now ended. For more exciting Colgate-Palmolive products and updates, visit us below:"
          ctaUrl="https://www.colgatepalmolive.com/en-us"
          cta="Learn More"
          imageUrl={header}
          variant="column"
          contentPosition="center"
          imagePosition="right"
          imageJustify="right"
          imageFit="contain"
          mobileContentOrder={1}
          mobileImageOrder={2}
          ctaUppercase={false}
          ctaJustify="center"
          preserveImageRatio={false}
        />
        <Logos />
        {/* <HowToParticipate url="/break/colgate-loyalty-receipt-upload" /> */}
        {/* <ShopNow /> */}
      </div>
      <LandingPageModal
        isOpen={dialog.isOpen}
        handleClose={handleClose}
        content={dialog.content}
        title={dialog.title}
      />
    </Layout>
  )
}

export default IndexPage
